type CustomerLike = { code: string; name: string; dcName?: string }

export const mapToCustomerFieldName = (
  customer: CustomerLike,
  shouldIncludeDcNameForSearch?: boolean
) => {
  return shouldIncludeDcNameForSearch
    ? `${customer.dcName}/${customer.code}/${customer.name}`
    : `${customer.code}/${customer.name}`
}
